import { dynamicElementsListMedia } from '@epicuro-next/constants/dynamic-elements';
import {
  LIST_ACCESS_PROVIDER_KEY,
  OPENED_LIST_DATA_PROVIDER_KEY,
} from '@epicuro-next/data-providers/providers-registry';
import { IDynamicItem } from '@epicuro-next/models/platform/dynamic-elements/dynamic-elements';

export const mediaConfigDefault: IDynamicItem = {
  contentTypeId: dynamicElementsListMedia,
  if: [
    'NOT',
    [
      'EQ',
      [
        {
          provider: OPENED_LIST_DATA_PROVIDER_KEY,
          property: 'mainMedia',
        },
        null,
      ],
    ],
  ],
  inputs: {
    media: {
      provider: OPENED_LIST_DATA_PROVIDER_KEY,
      property: 'mainMedia',
    },
    isOwner: {
      provider: LIST_ACCESS_PROVIDER_KEY,
      property: 'isOwnerOfOpenedList',
    },
    listId: {
      provider: OPENED_LIST_DATA_PROVIDER_KEY,
      property: 'id',
    },
  },
  outputs: {
    epicShowFullScreenChanged: [
      {
        type: 'custom-event',
        action: 'epc-epic-show-fullscreen-change',
      },
    ],
  },
};

export const mediaCommercialConfigDefault: IDynamicItem = {
  contentTypeId: dynamicElementsListMedia,
  inputs: {
    media: {
      provider: OPENED_LIST_DATA_PROVIDER_KEY,
      property: 'mainMedia',
    },
  },
};

export const mediaConfigBestseller: IDynamicItem = {
  contentTypeId: dynamicElementsListMedia,
  styles: {
    classes: ['standalone', 'max-h-80vh'],
  },
  inputs: {
    media: {
      provider: OPENED_LIST_DATA_PROVIDER_KEY,
      property: 'mainMedia',
    },
    isOwner: {
      provider: LIST_ACCESS_PROVIDER_KEY,
      property: 'isOwnerOfOpenedList',
    },
    listId: {
      provider: OPENED_LIST_DATA_PROVIDER_KEY,
      property: 'id',
    },
  },
};
